<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button v-if="$checkBtnPermission('/outputStore/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-button v-if="$checkBtnPermission('/outputStore/index', 'reset')" size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
			</template>
			<template #actions></template>
			<el-form-item label="所属门店：">
					<el-select filterable v-model="formInline.belongStoreKeyId" placeholder="请选择门店" clearable size="small" @change="getListData">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="出库单号：">
					<el-input clearable v-model="formInline.outputStoreNo" size="small" placeholder="请输入出库单号" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="顾客名称：">
					<el-input clearable v-model="formInline.customerName" size="small" placeholder="请输入顾客名称" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="顾客手机号：">
					<el-input clearable v-model="formInline.customerPhone" size="small" placeholder="请输入顾客手机号" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="订单号：">
					<el-input clearable v-model="formInline.orderNo" size="small" placeholder="请输入订单号" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="镜架信息：">
					<el-input clearable v-model="formInline.jjInformation" size="small" placeholder="请输入镜架信息" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="出库状态：">
					<el-select v-model.number="formInline.outputState" placeholder="请选择出库状态" size="small" @change="getListData">
						<el-option v-for="item in stateList" :key="item.code" :label="item.name" :value="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="出库时间：">
					<el-date-picker
						v-model="dateValue"
						clearable
						size="small"
						type="daterange"
						value-format="yyyy-MM-dd"
						format="yyyy-MM-dd"
						range-separator="~"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						@change="handleDateChange"
					></el-date-picker>
				</el-form-item>
			</lcsj-filter>
			<STable :columns="columnsData" :data="listData" :loading="loading" border @get-data="getListData" @row-click="handleRowClick">
				<template #outputStoreNo>
					<el-table-column align="center" label="出库单号" width="260">
						<template #default="scope">
							<el-link type="primary" @click="handleClickOutputStoreNo(scope.row)">
								{{ scope.row.outputStoreNo }}
							</el-link>
						</template>
					</el-table-column>
				</template>
			</STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<!-- 详情 -->
		<detail ref="detail"></detail>
	</div>
</template>

<script>
import { GetOutputStorePageList } from "@/api/receiptApi.js";
import { GetOrganizationListByConfig } from "@/api/organizationalApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import detail from "./detail.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "出库单列表"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			storeList: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			stateList: [],
			dateValue: [],
			selectionList: [],
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				customerName: "",
				customerPhone: "",
				belongStoreKeyId: "",
				outputStoreNo: "",
				orderNo: "",
				jjInformation: "",
				startTime: null,
				endTime: null,
				outputState: 0
			},
			columnsData: [], //显示列
			listColumns: [
				// {
				//   prop: "keyId",
				//   label: "全选",
				//   align: "center",
				//   fixed: "left",
				//   width: "55",
				//   isKeep: true,
				//   selection: true,
				// },
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					slot: "outputStoreNo",
					label: "出库单号",
					align: "center",
					width: "230",
					isKeep: true
				},
				{
					prop: "belongStoreName",
					label: "所属门店",
					align: "center",
					isKeep: true,
					width: "180"
				},
				{
					prop: "customerInfo.name",
					label: "顾客姓名",
					align: "center",
					isKeep: true,
					width: "80"
				},
				{
					prop: "outputDate",
					label: "出库时间",
					align: "center",
					isKeep: true,
					width: "160"
				},
				{
					prop: "customerInfo.phone",
					label: "顾客手机号",
					align: "center",
					isKeep: true,
					width: "150"
				},
				{
					prop: "orderDate",
					label: "下单日期",
					align: "center",
					isKeep: true,
					width: "160"
				},
				{
					prop: "getOrderDate",
					label: "取镜日期",
					align: "center",
					width: "160"
				},
				{
					prop: "yanGuangShi",
					label: "验光师",
					align: "center",
					width: "80"
				},
				{
					prop: "jjInformation",
					label: "镜架信息",
					align: "center",
					minWidth: "120"
				},
				{
					prop: "machinTypeStr",
					label: "加工类型",
					align: "center",
					minWidth: "120"
				},
				{
					prop: "outputStateStr",
					label: "出库状态",
					align: "center",
					width: "100"
				},
				{
					prop: "orderNo",
					label: "订单号",
					align: "center",
					width: "220"
				},
				{
					prop: "creator",
					label: "创建人",
					align: "center",
					minWidth: "80"
				},
				{
					prop: "createTime",
					label: "创建时间",
					align: "center",
					minWidth: "160"
				},
				{
					prop: "editor",
					label: "维护人",
					align: "center",
					minWidth: "80"
				},
				{
					prop: "updateTime",
					label: "维护时间",
					align: "center",
					minWidth: "160"
				}
			]
		};
	},
	// 注册组件
	components: {
		detail
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
		this.GetOrganizationListByConfig();
		this.GetEnumConfigListByCode();
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		handleDateChange(val) {
			if (val) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
		},
		//获取状态信息
		GetEnumConfigListByCode() {
			const paramer = {
				code: "OutputState"
			};
			GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.stateList = [];
						res.data.forEach((item) => {
							this.stateList.push({
								code: parseInt(item.code),
								name: item.name
							});
						});
						this.stateList.unshift({
							code: 0,
							name: "全部"
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取状态信息失败!");
				});
		},
		handleCommand(command) {
			// 1编辑
			switch (command.command) {
				case "4":
					this.deleteCustomer(command.rowData);
					break;
				default:
					console.log(command);
			}
		},
		// 单击行数据
		handleRowClick(row) {
			// this.$refs.edit.editShow(row);
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetOutputStorePageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.search();
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 获取所属门店
		GetOrganizationListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrganizationListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 点击出库单号
		handleClickOutputStoreNo(row) {
			this.$refs.detail.showDetailDialog(row.keyId);
		}
	}
};
</script>

<style scoped>

</style>
